import * as _ from "lodash";
import { TromanError } from "../../common/TromanError";

interface IValidExtension {
    Extension: string;
    AsAttachment: boolean;
    AsImage: boolean;
}

enum PayrollSystem {
    None = 0,
    Heroma1 = 1,
    Heroma2 = 2,
    Heroma3 = 3,
    Ecompanion = 4,
    Hrplus = 5,
    HrplusGotland = 6,
    Personec = 7,
    Hrm = 8,
    Heroma4Std = 9,
    HrplusUddevalla = 10,
    SdWorx = 11,
}

interface ISystemInfoResult
{
    PayrollSystem: PayrollSystem;
    IsPolitikerEnabled: boolean;
    IsSparLookupEnabled: boolean;
    IsSparNotificationsEnabled: boolean;
    EndingMandateDays: number | null | undefined;
    PolitikerReportingDays: number;
    IsWarningMissingMeetingPaymentEnabled: boolean;
    IsSSOEnabled: boolean;
    ValidExtensions: IValidExtension[];
}

function getPayrollSystemName(payrollSystemId: PayrollSystem) {
    switch (payrollSystemId) {
        case PayrollSystem.None: return "Inget lönesystem";
        case PayrollSystem.Heroma1: return "Heroma"; // Heroma-1
        case PayrollSystem.Heroma2: return "Heroma"; // Heroma-2
        case PayrollSystem.Heroma3: return "Heroma"; // Heroma-3
        case PayrollSystem.Ecompanion: return "eCompanion";
        case PayrollSystem.Hrplus: return "Hrplus"; // Hrplus old
        case PayrollSystem.HrplusGotland: return "Hrplus (Gotland)"; // Hrplus11-Gotland
        case PayrollSystem.Personec: return "Personec P";
        case PayrollSystem.Hrm: return "HRM";
        case PayrollSystem.Heroma4Std: return "Heroma"; // Heroma-4
        case PayrollSystem.HrplusUddevalla: return "Hrplus"; // Hrplus11
        case PayrollSystem.SdWorx: return "SD Worx";
        default: throw new TromanError("unknown_payrollsystemid", "Okänt lönesystem", payrollSystemId);
    }
}

export class SystemInfo {
    PayrollSystemName: string;
    EnableTransactions: boolean;
    IsSparLookupEnabled: boolean;
    IsSparNotificationsEnabled: boolean;
    EndingMandateDays: number;
    IsPolitikerEnabled: boolean;
    PolitikerReportingDays: number;
    IsWarningMissingMeetingPaymentEnabled: boolean;
    IsSSOEnabled: boolean;
    AttachmentExtensions: string[];
    AttachmentExtensionsAccept: string;
    ImageExtensions: string[];
    ImageExtensionsAccept: string;

    constructor(src: ISystemInfoResult, _responseContext: any) {
        this.PayrollSystemName = getPayrollSystemName(src.PayrollSystem);
        this.EnableTransactions = src.PayrollSystem > 0;
        this.IsSparLookupEnabled = src.IsSparLookupEnabled;
        this.IsSparNotificationsEnabled = src.IsSparNotificationsEnabled;
        this.IsPolitikerEnabled = src.IsPolitikerEnabled;
        this.PolitikerReportingDays = src.PolitikerReportingDays;
        this.IsWarningMissingMeetingPaymentEnabled = src.IsWarningMissingMeetingPaymentEnabled;
        this.IsSSOEnabled = src.IsSSOEnabled;
        this.AttachmentExtensions = _.map(_.filter(src.ValidExtensions, x => x.AsAttachment), x => x.Extension);
        this.AttachmentExtensionsAccept = this.AttachmentExtensions.join(',');
        this.ImageExtensions = _.map(_.filter(src.ValidExtensions, x => x.AsImage), x => x.Extension);
        this.ImageExtensionsAccept = this.ImageExtensions.join(',');

        if (!_.isNumber(src.EndingMandateDays) || src.EndingMandateDays < 1 || src.EndingMandateDays > 365) {
            this.EndingMandateDays = 30;
        } else {
            this.EndingMandateDays = src.EndingMandateDays;
        }
    }
}
